import * as React from "react";
import { useDataProvider, useNotify } from "react-admin";
import { useNavigate } from "react-router-dom";
import { Cargo } from "../models/Cargo";
import {
  MAP_DRIVER_FETCH_FAILED_MESSAGE,
  MAP_DRIVER_MISSING_COORDINATES_MESSAGE,
  buildMapDriversPath,
  getMapNavigationPayload,
} from "../utils/map-drivers-navigation";

/**
 * 根据选中货源拉取详情并跳转到地图司机页。
 */
export const useNavigateToMapDrivers = (selectedCargo: Cargo | null) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = React.useState(false);

  const goToMapDrivers = React.useCallback(async () => {
    if (!selectedCargo?.id || isNavigating) {
      return;
    }

    setIsNavigating(true);

    try {
      const { data } = await dataProvider.getOne("validCargos", {
        id: selectedCargo.id,
      });
      const detailCargo = data as Cargo;
      const mapNavigationPayload = getMapNavigationPayload(detailCargo);

      if (!mapNavigationPayload) {
        notify(MAP_DRIVER_MISSING_COORDINATES_MESSAGE, { type: "warning" });
        return;
      }

      navigate(buildMapDriversPath(mapNavigationPayload));
    } catch (error) {
      notify(MAP_DRIVER_FETCH_FAILED_MESSAGE, { type: "error" });
    } finally {
      setIsNavigating(false);
    }
  }, [dataProvider, isNavigating, navigate, notify, selectedCargo]);

  return {
    isNavigating,
    goToMapDrivers,
  };
};
